import { Navigate } from 'react-router-dom';

import useAuth from 'hooks/useAuth';

export default function RootRedirect() {
  const { isLoggedIn } = useAuth();

  return <Navigate to={isLoggedIn ? '/dashboard/default' : '/signin'} replace />;
}
